import React from "react";
import { type DropdownWithoutOptionsProps } from "../models";
import BaseReactSelectDropdown from "./BaseReactSelectDropdown";

const TravelClassDropdown = (props: DropdownWithoutOptionsProps<server.dto.FlightTravelClass, server.dto.FlightTravelClasses>) => {
  return <BaseReactSelectDropdown
    excludeKeys={["unknown"]}
    options={serverReference.flightTravelClasses}
    getLabel={p => p.text}
    getValue={(t) => t.value}
    value={props.value}
    onChange={props.onChange}
    onEsc={props.onEsc}
    config={{
      ...props.config,
      isClearable: true,
    }}
  />;
};

export default TravelClassDropdown;